import { render, staticRenderFns } from "./zbpie.vue?vue&type=template&id=9cbe24f0&scoped=true&"
import script from "./zbpie.vue?vue&type=script&lang=js&"
export * from "./zbpie.vue?vue&type=script&lang=js&"
import style0 from "./zbpie.vue?vue&type=style&index=0&id=9cbe24f0&scoped=true&lang=css&"
import style1 from "./zbpie.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbe24f0",
  null
  
)

export default component.exports